import { alpha } from '@mui/material/styles'
import { MOBILE_SECTION_DIVIDER_COLOR } from './mobileColors'

export const MOBILE_EXPANDABLE_SUMMARY_ROW_SX = {
  py: 0.65
}

export const getMobileExpandableSummaryLabelSx = (fontSize = 11.52) => ({
  textTransform: 'uppercase',
  letterSpacing: 0.04,
  fontWeight: 600,
  fontSize
})

export const MOBILE_EXPANDABLE_SUMMARY_LABEL_SX = getMobileExpandableSummaryLabelSx()

export const getMobileExpandableSummaryValueSx = (
  accentColor,
  fontSize = 16,
  valueColor
) => ({
  wordBreak: 'break-word',
  color: valueColor || accentColor,
  fontSize,
  lineHeight: 1.45
})

export const MOBILE_EXPANDABLE_SUMMARY_VALUE_SX = (accentColor) => getMobileExpandableSummaryValueSx(accentColor)


export const getMobileExpandableDetailRowSx = (theme, options = {}) => {
  const { lighterDivider = false, dividerColor } = options
  const isDark = theme.palette.mode === 'dark'
  const dividerAlpha = isDark ? 0.55 : lighterDivider ? 0.28 : 1
  return {
    py: 1.25,
    borderBottom: `1px solid ${dividerColor || alpha(theme.palette.divider, dividerAlpha)}`,
    '&:last-of-type': { borderBottom: 'none', pb: 0 }
  }
}

export const getMobileExpandableDetailAvatarSx = (theme) => ({
  width: 36,
  height: 36,
  flexShrink: 0,
  bgcolor: alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.12 : 0.08),
  color: 'text.secondary'
})

export const MOBILE_EXPANDABLE_DETAIL_CONTENT_SX = {
  minWidth: 0,
  flex: 1
}

export const getMobileExpandableDetailLabelSx = (fontSize = 11.2) => ({
  letterSpacing: 0.04,
  mb: 0.25,
  fontWeight: 600,
  textTransform: 'uppercase',
  fontSize
})

export const MOBILE_EXPANDABLE_DETAIL_LABEL_SX = getMobileExpandableDetailLabelSx()

export const getMobileExpandableDetailValueSx = (
  accentColor,
  fontSize = 14,
  valueColor
) => ({
  color: valueColor || accentColor,
  fontSize,
  lineHeight: 1.45
})

export const MOBILE_EXPANDABLE_DETAIL_VALUE_SX = (accentColor) => getMobileExpandableDetailValueSx(accentColor)

export const getMobileExpandableCardSx = (theme) => {
  const isDark = theme.palette.mode === 'dark'
  const borderColor = isDark
    ? alpha(theme.palette.common.white, 0.22)
    : alpha(theme.palette.grey[900], 0.2)
  const cardShadow = isDark
    ? '0 1px 4px rgba(0,0,0,0.35), 0 4px 16px rgba(0,0,0,0.35)'
    : '0 1px 2px rgba(0,0,0,0.05), 0 2px 8px rgba(0,0,0,0.06)'

  return {
    width: '100%',
    height: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: `1px solid ${borderColor}`,
    boxShadow: cardShadow,
    overflow: 'hidden'
  }
}

export const getMobileExpandableCardContentSx = ({
  bodyFontSize = 16,
  lineHeight = 1.45
} = {}) => ({
  width: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  pt: 2,
  pb: 2,
  px: 2,
  fontSize: bodyFontSize,
  '& .MuiTypography-root': { fontSize: bodyFontSize, lineHeight },
  '&:last-child': { pb: 2 }
})

export const MOBILE_EXPANDABLE_CARD_CONTENT_SX = getMobileExpandableCardContentSx()

export const MOBILE_EXPANDABLE_CODE_TRIGGER_BASE_SX = {
  flex: 1,
  minWidth: 0,
  m: 0,
  p: 0,
  border: 'none',
  background: 'none',
  textAlign: 'left',
  font: 'inherit',
  color: 'inherit'
}

export const getMobileExpandableCodeTriggerSx = (onCodeClick) => ({
  ...MOBILE_EXPANDABLE_CODE_TRIGGER_BASE_SX,
  cursor: onCodeClick ? 'pointer' : 'default'
})

export const getMobileExpandableCodeTextSx = (accentColor, fontSize = 16) => ({
  color: accentColor,
  fontSize,
  lineHeight: 1.45,
  textDecoration: 'underline',
  textUnderlineOffset: 3,
  wordBreak: 'break-word'
})

export const MOBILE_EXPANDABLE_CODE_TEXT_SX = (accentColor) => getMobileExpandableCodeTextSx(accentColor)

export const MOBILE_EXPANDABLE_EXPAND_BUTTON_SX = (accentColor) => ({
  flexShrink: 0,
  mt: -0.25,
  color: accentColor
})

export const getMobileExpandableFooterWrapSx = ({
  footerDivider = false,
  footerDividerColor,
  footerPaddingTop = 1
} = {}) => ({
  mt: 'auto',
  width: '100%',
  pt: footerPaddingTop,
  ...(footerDivider
    ? {
        borderTop: `1px solid ${footerDividerColor || MOBILE_SECTION_DIVIDER_COLOR}`
      }
    : {})
})
